// extracted by mini-css-extract-plugin
export default {"container":"styles_container__Y1HRi","content":"styles_content__QAEjv","moreLessButton":"styles_moreLessButton__BmIwJ"};